module.exports = __webpack_public_path__ + "img/Sandburg.2fe77119.jpg";